import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=262881da&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports